<header class="app-header-strip" [ngClass]="{'hidden-on-mobile' : !showHideApplicationHeaderService.isVisible()}"
		dir="ltr"
		cpHideWhenPopupOpen>
	<div class="left-side">
		<img aria-hidden= "true" class="logo" [src]="logo ? logo : ''"  alt="Logo" />
	</div>

	<div class="right-side">
		<app-language-selection></app-language-selection>
	</div>
</header>

<div class="app-container">
	<router-outlet></router-outlet>
	<div class="k-overlay" *ngIf="popupWindowService.anyPopupsOpen | async"></div>
	<div class="notification-container" #notificationContainer></div>
</div>

<ng-template #closePopupTitle>
	<div class="popup-header">
		<div class="popup-title" id="close-popup-title">{{"AreYouSureYouWantToLeave" | cpTitleTranslate | async}}</div>
		<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup(false)"></i>
	</div>
</ng-template>

<ng-template #closePopupContent>
	<div class="popup-body">
		<div class="popup-body-text-content">
			<i class="pp-icon-error"></i>
			<div>
				<div class="text-bold">{{"AreYouSureYouWantToLeave" | cpLabelTranslate | async}}</div>
				<div>{{"AnyChangesYouMadeMayBeLost" | cpLabelTranslate | async}}</div>
				<div>{{"DoYouWantToLogOut" | cpLabelTranslate | async}}</div>
			</div>
		</div>
	</div>

	<div class="popup-footer">
		<cp-button class="link-button" captionToTranslate="Logout" (onClick)="popupWindowService.closeLatestPopup(true)"></cp-button>
		<cp-button class="primary-button" captionToTranslate="Cancel" (onClick)="popupWindowService.closeLatestPopup(false)"></cp-button>
	</div>
</ng-template>
